import { render, staticRenderFns } from "./VatRates.vue?vue&type=template&id=2df7d0ea&scoped=true&"
import script from "./VatRates.vue?vue&type=script&lang=js&"
export * from "./VatRates.vue?vue&type=script&lang=js&"
import style0 from "./VatRates.vue?vue&type=style&index=0&id=2df7d0ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df7d0ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VRating})
